export const LOGIN_SUCCESS = "LOGIN_SUCCESS" //会员登录操作
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS" //会员退出登录操作
export const INIT_BANNER = "INIT_BANNER" //加载banner


// WEBPACK FOOTER //
// ./src/actions/action-type.js


// WEBPACK FOOTER //
// ./src/actions/action-type.js